export const REFUND = 'REFUND';
export const REFUND_ALL = `${REFUND}/ALL`;
export const REFUND_SEARCH = `${REFUND}/SEARCH`;
export const SEND_RECEIPT = `${REFUND}/SEND_RECEIPT`;
export const REFUND_EXPORT = `${REFUND}/EXPORT`;
